import { Stack, PrimaryButton, DefaultButton } from "@fluentui/react";
import { styled } from "styled-components";

export const ActionsSection = styled.section`
  background-color: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e1e3e5;
`;

export const ActionButtonsContainer = styled(Stack)`
  gap: 12px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ActionButton = styled(PrimaryButton)`
  min-width: 170px;
  height: 32px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 767px) {
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
  }
`;

export const ActionDefaultButton = styled(DefaultButton)`
  min-width: 170px;
  height: 32px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 767px) {
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
  }
`;
